import React from 'react';
import ImportShopItem from '../Domain/ImportShopItem.js';
import AuthService from './authService.js';
import SearchParams from '../Elements/SearchParams';
import ImportShopSearchParams from '../Contents/RoverImport/ImportShopAdmin/ImportShopSearchParams';

class ImportShopService extends React.Component {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, ImportShopSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/ImportShop/GetAllBySearchingAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    let mappedItems = [];

    if (itemlist !== null) {
      mappedItems = itemlist.map((item) => new ImportShopItem(item));
    }

    return mappedItems;
  }

  static StartImportManually() {
    var url = '/api/ImportShop/ManualStartGetDataFromClientAsync';

    return AuthService.getInstance().CallBackendFunctionPost(url);
  }

  static GetPublicIp() {
    var url = '/api/ImportShop/GetPubIpAsync';

    return AuthService.getInstance().CallBackendFunction(url);
  }
}

export default ImportShopService;
